// The find player > league filter Alpine object
window.appLeagueFilter = () => {
    return {
        label: '',
        initialLabel: '',
        expanded: false,
        query: '',
        leagues: [],

        toggleExpanded() {
            if( this.expanded ) {
                this.expanded = false;
                return;
            }

            // hide the player matches popput if this is expanded
            if(document.querySelector('[x-id=appFindPlayers]')) {
                $c('appFindPlayers').playerMatches.active = false;
            }

            //open the search popout
            this.expanded = true;

            //focus the query input
            this.$nextTick( () => this.$refs.searchQuery.focus() );

        },

        init: function() {
            //set labels
            this.initialLabel = getLang('benchmarked_leagues');
            this.label = getLang('benchmarked_leagues');

            axios.get('/api/leagues/')
                .then( response => {
                    this.leagues = Object.create( response.data );

                    // add in Benchmarked leagues
                    this.leagues.unshift({ id: 0, name: getLang('benchmarked_leagues'), countryId: 0, countryName: '' });

                    // if the league ID is already set, then set the label
                    if( this.$store.inputs.current.leagueIds.length ) {
                        this.label = this.$store.inputs.current.leagueIds.length === 1
                            ? this.$store.inputs.current.leagueIds[0] === 0 ? getLang('benchmarked_leagues') : this.leagues[this.leagues.findIndex(i => i.id == this.$store.inputs.current.leagueIds)].name
                            : getLang('multiple_leagues') + ' (' + this.$store.inputs.current.leagueIds.length + ')';
                    }
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        select: function( league ) {
            // standard mode - one league only
            if( standard() ) {
                this.label = league.name; //set the label of the select box
                this.$store.inputs.current.leagueIds = [league.id]; //store the value
                this.expanded = false; //hide popout
                this.query = ''; //clear filter query

            } else if( pro() || elite() ){

                // benchmarked leagues?
                if( league.id === 0 ) {
                    this.$store.inputs.current.leagueIds = [0]; //remove all other leagues
                } else {
                    //remove benchmarked leagues
                    if( this.$store.inputs.current.leagueIds[0] == 0) {
                        this.$store.inputs.current.leagueIds.splice(this.$store.inputs.current.leagueIds.indexOf(0),1);
                    }

                    // toggle this league in the array of leagues
                    if( this.$store.inputs.current.leagueIds.includes(league.id) ) {
                        this.$store.inputs.current.leagueIds.splice(this.$store.inputs.current.leagueIds.indexOf(league.id),1);
                    } else {
                        this.$store.inputs.current.leagueIds.push(league.id)
                    }
                }

                // update the label
                this.label = this.$store.inputs.current.leagueIds.length === 1
                    ? league.id === 0 ? getLang('benchmarked_leagues') : league.name
                    : getLang('multiple_leagues') + ' (' + this.$store.inputs.current.leagueIds.length + ')'; //set the label of the select box

                // if no leagues are set now, default to benmarked leagues
                if(this.$store.inputs.current.leagueIds.length === 0) {
                    this.init();
                    this.$store.inputs.current.leagueIds = [0];
                }
            }
        },

        get filteredLeagues() {
            if (this.query === "") { //if no query is set, do nothing
                return this.leagues;
            }

            return this.leagues.filter((item) => { //return a list of filtered items
                return item.id != 0 &&
                    item.name.toLowerCase().includes(
                        this.query.toLowerCase()
                    );
            });
        }
    }
};

// The find player > league filter Alpine object (without using benchmarked leagues)
window.appLeagueFilterNoBM = (initialLabel, limit) => {
    return {
        label: '',
        initialLabel,
        limit, // set a hard limit of leagues that can be selected
        expanded: false,
        query: '',
        leagues: [],

        toggleExpanded() {
            if( this.expanded ) {
                this.expanded = false;
                return;
            }

            // hide the player matches popput if this is expanded
            if(document.querySelector('[x-id=appFindPlayers]')) {
                $c('appFindPlayers').playerMatches.active = false;
            }

            //open the search popout
            this.expanded = true;

            //focus the query input
            this.$nextTick( () => this.$refs.searchQuery.focus() );

        },

        init: function() {
            //set labels
            this.label = this.initialLabel;

            axios.get('/api/leagues/')
                .then( response => {
                    this.leagues = Object.create( response.data );

                    // if the league ID is already set, then set the label
                    if( this.$store.inputs.current.leagueIds.length ) {
                        this.label = this.$store.inputs.current.leagueIds.length === 1
                            ? this.leagues[this.leagues.findIndex(i => i.id == this.$store.inputs.current.leagueIds)].name
                            : getLang('multiple_leagues') + ' (' + this.$store.inputs.current.leagueIds.length + '/' + this.limit + ')';
                    }

                    // hide the loading screen
                    $c('appMain').loading = false;
                })
                .catch( response => {
                    modal(getLang('generic_error'));
                })
        },

        select: function( league ) {
            // standard mode - one league only
            if( standard() ) {
                this.label = league.name; //set the label of the select box
                this.$store.inputs.current.leagueIds = [league.id]; //store the value
                this.expanded = false; //hide popout
                this.query = ''; //clear filter query

            } else if( pro() || elite() ){

                // toggle this league in the array of leagues
                if( this.$store.inputs.current.leagueIds.includes(league.id) ) {
                    this.$store.inputs.current.leagueIds.splice(this.$store.inputs.current.leagueIds.indexOf(league.id),1);
                // only add if the current amount of leagues is less than the total limit
                } else if(this.$store.inputs.current.leagueIds.length < this.limit) {
                    this.$store.inputs.current.leagueIds.push(league.id)
                }

                // update the label
                this.label = this.$store.inputs.current.leagueIds.length === 1
                    ? this.leagues[this.leagues.findIndex(i => i.id == this.$store.inputs.current.leagueIds[0])].name
                    : getLang('multiple_leagues') + ' (' + this.$store.inputs.current.leagueIds.length + '/' + this.limit + ')'; //set the label of the select box

                // if no leagues are set now, default to initial label
                if(this.$store.inputs.current.leagueIds.length === 0) {
                    this.label = this.initialLabel;
                }
            }
        },

        get filteredLeagues() {
            if (this.query === "") { //if no query is set, do nothing
                return this.leagues;
            }

            return this.leagues.filter((item) => { //return a list of filtered items
                return item.id != 0 &&
                    item.name.toLowerCase().includes(
                        this.query.toLowerCase()
                    );
            });
        }
    }
};
